module.exports = __webpack_public_path__ + "static/media/020admin_7 verify details@2x.13784743.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/020admin_7 verify details@2x.png
// module id = 585
// module chunks = 0